var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29994 0L3.58328 0.727273H0V2.18182H0.716657V13.0909C0.716657 13.8859 1.36662 14.5455 2.14997 14.5455H7.88322V13.0909H2.14997V2.18182H9.31654V9.45455H10.7499V2.18182H11.4665V0.727273H10.7499H7.88322L7.16657 0H4.29994ZM3.58328 3.63636V11.6364H5.0166V3.63636H3.58328ZM6.44991 3.63636V11.6364H7.88322V3.63636H6.44991ZM9.94641 10.858L8.93301 11.8864L10.4531 13.429L8.93301 14.9716L9.94641 16L11.4665 14.4574L12.9866 16L14 14.9716L12.4799 13.429L14 11.8864L12.9866 10.858L11.4665 12.4006L9.94641 10.858Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.9244f29c.svg";
export { ForwardRef as ReactComponent };